var defaultFontName = 'Concert One';
var Animation = /** @class */ (function () {
    function Animation(props) {
        this.time = 0;
        this.maxTime = 1000;
        this.done = false;
        this.props = props;
    }
    Animation.prototype.upd = function (dt) {
        this.time += dt;
    };
    Animation.prototype.isDone = function () {
        if (this.time >= this.maxTime && !this.done) {
            if (this.props.onDone) {
                this.props.onDone();
                this.props.onDone = null;
            }
            this.done = true;
        }
        return this.done;
    };
    Animation.prototype.needRedraw = function () {
        return true;
    };
    Animation.prototype.fillText = function (scene, text, y, delay, fontSize, fontName) {
        if (fontName === void 0) { fontName = defaultFontName; }
        if (this.time > delay) {
            fontSize = Math.min(fontSize, Math.ceil(5 + (this.time - delay) * 0.05));
            scene.font(fontSize, fontName);
            scene.fillCenterText(text, y);
        }
    };
    Animation.prototype.fillTextXY = function (scene, text, x, y, delay, fontSize, speed, fontName, fontWeight) {
        if (speed === void 0) { speed = 0.05; }
        if (fontName === void 0) { fontName = defaultFontName; }
        if (this.time > delay) {
            fontSize = Math.min(fontSize, Math.ceil(5 + (this.time - delay) * speed));
            scene.font(fontSize, fontName, fontWeight);
            scene.fillText(text, x - scene.textWidth(text) / 2, y);
        }
    };
    return Animation;
}());
export { Animation };
